import React from "react";
import moment from "moment";
import themeImages from "../../../../helpers/images";
import Checklist from "../Checklist";
import SingleClockIn from "./SingleClockIn";
import MultipleClockIn from "./MultipleClockIn";
import { GET, newFetch } from "../../../../helpers/fetch";

import "../styles.css";

const StartTimeclock = ({
  user,
  isClockInToday,
  masterClockInOutHandler,
  loading,
  selectedSchedule,
  attendanceLogs,
  isClockOutToday,
  featuresOnOff,
  activeSite,
  setAnswers,
  answers,
  group,
  defaultSiteData,
  overNightShift,
  refreshScheduleData,
  isWithin5Hours,
  t,
}) => {
  const [lastRecentActivityIN, setLastRecentActivityIN] = React.useState(null);
  const [lastRecentActivityOUT, setLastRecentActivityOUT] =
    React.useState(null);
  const [lastRecentActivityBreakIN, setLastRecentActivityBreakIN] =
    React.useState(null);
  const [lastRecentActivityBreakOUT, setLastRecentActivityBreakOUT] =
    React.useState(null);
  const [calculatedBreakTime, setCalculatedBreakTime] = React.useState(null);
  const [isNewTimeOutClock, setIsNewTimeOutClock] = React.useState(true);
  const [checklist, setChecklist] = React.useState([]);

  React.useEffect(() => {
    if (!attendanceLogs.length || !selectedSchedule?.id) return;

    const today = moment().format("YYYY-MM-DD");

    const todayLogs = attendanceLogs.filter((item) => {
      return (
        item.schedule_id === selectedSchedule.id &&
        moment(item.date).format("YYYY-MM-DD") === today
      );
    });

    const findByType = (type) =>
      todayLogs.find((item) => item.type === type) || null;

    setLastRecentActivityIN(findByType("checkin"));
    setLastRecentActivityOUT(findByType("checkout"));
    setLastRecentActivityBreakIN(findByType("breakin"));
    setLastRecentActivityBreakOUT(findByType("breakout"));
  }, [attendanceLogs, selectedSchedule]);

  React.useEffect(() => {
    lastRecentActivityBreakOUT?.punchtime && calculateBreakTime();
  }, [lastRecentActivityBreakOUT]);

  React.useEffect(() => {
    lastRecentActivityOUT?.punchtime && calculateTodayTimeOutClock();
  }, [lastRecentActivityOUT]);

  React.useEffect(() => {
    activeSite && fetchChecklist();
  }, [activeSite]);

  const calculateBreakTime = () => {
    // Convert punchtime strings to Moment objects
    const breakOutTime = moment(
      lastRecentActivityBreakOUT?.punchtime,
      "YYYY-MM-DD HH:mm"
    );
    const breakInTime = moment(
      lastRecentActivityBreakIN?.punchtime,
      "YYYY-MM-DD HH:mm"
    );

    // Calculate the difference in minutes
    const duration = moment.duration(breakOutTime.diff(breakInTime));
    const hours = Math.floor(duration.asHours()); // Get whole hours
    const minutes = duration.minutes(); // Get remaining minutes

    setCalculatedBreakTime(`${hours}h ${minutes}m`);
  };

  const calculateTodayTimeOutClock = () => {
    const today = moment().startOf("day");
    const lastTimeOutDate = moment(lastRecentActivityOUT).startOf("day");

    if (today.isAfter(lastTimeOutDate)) {
      setIsNewTimeOutClock(true);
    } else {
      setIsNewTimeOutClock(false);
    }
  };

  const fetchChecklist = async () => {
    let api_path = `/site/${activeSite}/checklists`;
    let response = await newFetch(GET, api_path);

    if (response.success) {
      let data = response.data;
      setChecklist(data);
    }
  };

  return (
    <React.Fragment>
      {!featuresOnOff.feature && (
        <div className="timeclock-workspace">
          {defaultSiteData && !defaultSiteData.enable_multiple_clockinout && (
            <SingleClockIn
              user={user}
              isClockInToday={isClockInToday}
              themeImages={themeImages}
              masterClockInOutHandler={masterClockInOutHandler}
              loading={loading}
              lastRecentActivityIN={lastRecentActivityIN}
              lastRecentActivityOUT={lastRecentActivityOUT}
              lastRecentActivityBreakIN={lastRecentActivityBreakIN}
              calculatedBreakTime={calculatedBreakTime}
              setAnswers={setAnswers}
              answers={answers}
              checklist={checklist}
              attendanceLogs={attendanceLogs}
              isClockOutToday={isClockOutToday}
              defaultSiteData={defaultSiteData}
              selectedSchedule={selectedSchedule}
              overNightShift={overNightShift}
              isWithin5Hours={isWithin5Hours}
              refreshScheduleData={refreshScheduleData}
            />
          )}

          {defaultSiteData && defaultSiteData.enable_multiple_clockinout && (
            <MultipleClockIn
              user={user}
              isClockInToday={isClockInToday}
              themeImages={themeImages}
              masterClockInOutHandler={masterClockInOutHandler}
              loading={loading}
              lastRecentActivityIN={lastRecentActivityIN}
              lastRecentActivityOUT={lastRecentActivityOUT}
              lastRecentActivityBreakIN={lastRecentActivityBreakIN}
              calculatedBreakTime={calculatedBreakTime}
              setAnswers={setAnswers}
              answers={answers}
              checklist={checklist}
              attendanceLogs={attendanceLogs}
              isClockOutToday={isClockOutToday}
              group={group}
              t={t}
              defaultSiteData={defaultSiteData}
              selectedSchedule={selectedSchedule}
              overNightShift={overNightShift}
              isWithin5Hours={isWithin5Hours}
              refreshScheduleData={refreshScheduleData}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default StartTimeclock;
